<template>
  <material-card
    :title="$t('views.members.pending_self_payments')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="payments"
    v-if="selectedPlan !== null && selectedPlan !== undefined"
  >
    <pbas-data-table
    v-if="deposited==='non-deposited'"
      ref="table"
      :exporters="$exporters"
      :dataProvider="provider"
      :selectAll="true"
      :showSelect="true"
      :selectActions="selectActions"
      :rowActions="rowActions"
      fileNamePrefix="pending-self-payments"
      identifier="pendingSelfPayments"
      @error="error = $event"
    ></pbas-data-table>
    <pbas-data-table
    v-else
      ref="table"
      :exporters="$exporters"
      :dataProvider="provider"
      :showSelect="false"
      :rowActions="rowActions"
      fileNamePrefix="pending-self-payments"
      identifier="pendingSelfPayments"
      @error="error = $event"
    ></pbas-data-table>
    <error-handler :error="error"></error-handler>
    <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="depositDialog" persistent max-width="500">
      <material-card
        v-if="selectedItems"
        :title="$t('views.pendingselfpayments.deposit_dialog_title')"
        :color="$vuetify.theme.themes.light.primary"
        icon="payment"
      >
        <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
        <v-card-actions>
          <v-btn color text @click="depositDialog = false" :loading="saving">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" text @click="tryDeposit" :loading="saving">
            {{ $t("views.pendingselfpayments.deposit") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
  </material-card>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import ErrorHandler from "../components/ErrorHandler";
import { planSetter } from "../mixins/planSetter";
import getHeaders from "../headers/PendingSelfPayments";

export default {
  props: ["deposited"],
  components: {
    ErrorHandler,
  },
  mixins: [planSetter],
  data() {
    return {
      loading: false,
      selectedItems: null,
      provider: undefined,
      depositDialog: false,
      error: null,
      rowActions: [
        {
          name: "deposit",
          icon: "payment",
          title: "views.pendingselfpayments.deposit",
          handler: (item) => {
            this.selectedItems = [];
            this.selectedItems.push(item);
            this.depositDialog = true;
          },
          visible: (item) => item.Deposited === false,
        },
      ],
      selectActions: [],
      saving: false,
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
    deposited: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  async mounted() {
    this.loadPlanData();
  },
  methods: {
    ...mapActions("plansMembers", ["deposit"]),
    loadPlanData() {
      if (
        this.selectedPlan !== null &&
        this.selectedPlan !== undefined &&
        this.deposited !== null &&
        this.deposited !== undefined
      ) {
        let headers = getHeaders(this.options.Enums);
        let provider = new PbasOData(
          this.$axiosHttp,
          "plans/" + this.selectedPlan.Id + "/self-payments",
          headers
        );
        if (this.deposited === "deposited") {
          provider.filter = "Deposited eq true";
        } else if (this.deposited === "non-deposited") {
          provider.filter = "Deposited eq false";
          this.selectActions = [
            {
              name: "deposit",
              icon: "payment",
              title: "views.pendingselfpayments.deposit",
              handler: (items) => {
                this.selectedItems = this.$refs.table.selected.filter(
                  (o) => o.Deposited === false
                );
                // this.selectedItems = items;
                this.depositDialog = true;
              },
            },
          ];
        }
        this.provider = provider;
      }
    },
    async tryDeposit() {
      const options = {
        payload: this.selectedItems.map((o) => o.Id),
      };
      try {
        this.saving = true;
        await this.deposit(options);
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
        this.depositDialog = false;
        this.$refs.table.getDataAsync();
      }
    },
  },
};
</script>
